<template>
  <main class="d-flex flex-column h-100">
    <ContentHeader @collapsedSider="collapsedSider" :rotateIcon="rotateIcon" @triggerExport="triggerExport" @shareModal="shareModal" :value="!isCollapsed" @on-menu-icon-click="onMenuItemClick"></ContentHeader>

    <Layout :class="isCollapsed ? 'app-drawer-collapsed':'app-drawer-open'" class="d-flex flex-column">
      <Sider ref="sideMenu" id="menu" class="main-menu"
            collapsible
            breakpoint="sm"
            :collapsed-width="0" width="320"
            v-model="isCollapsed"
            v-if="$route.name!='Authentication'">
        <div class="d-flex flex-column h-100">
          <div class="k4-selectionContainer px-2">
            <div class="k4-selectionContainer__wrapper p-2">
              <div v-show="getAdminUser" class="py-1">
                <label><Icon class="ico" size="25" type="md-briefcase"></Icon> Select your Company :</label>
                <AutoComplete on-select="changeCompanyId" clearable placeholder="Select Company" size="large"
                              :data="companyList" :filter-method="filterMethod" v-model="selectedCompany"
                              icon="ios-search">
                </AutoComplete>
              </div>

              <div class="py-1">
                <label><Icon class="ico" size="25" type="md-globe"></Icon> Select your Event :</label>
                <AutoComplete on-select="changeEventId" clearable placeholder="Select Event" size="large"
                              :filter-method="filterMethod" v-model="selectedEvent" icon="ios-search">
                  <Option ref="eventName" v-for="item in eventListDefault" :value="item.eventName"
                          :key="item.eventName">
                    {{ item.eventName }}
                  </Option>
                  <div v-show="eventListExpired&&eventListExpired.length>0" class="demo-auto-complete-group">
                    <span>Expired</span>
                  </div>
                  <Option ref="eventName" v-for="item in eventListExpired" :value="item.eventName"
                          :key="item.eventName">
                    <span class="demo-auto-complete-title">{{ item.eventName }}</span>
                  </Option>
                  <div v-show="eventListUpcoming&&eventListUpcoming.length>0" class="demo-auto-complete-group">
                    <span>Upcoming</span>
                  </div>
                  <Option ref="eventName" v-for="item in eventListUpcoming" :value="item.eventName"
                          :key="item.eventName">
                    <span class="demo-auto-complete-title">{{ item.eventName }}</span>
                  </Option>
                </AutoComplete>
              </div>
            </div>
          </div>

          <div class="d-flex flex-grow-1">
            <div class="k4-key4leadLogoContainer d-flex justify-content-center align-items-start h-100">
              <img class="k4-key4leadLogoContainer__image py-5" src="../assets/key4lead_logo_text_blue_vertical.png"/>
            </div>

            <div class="w-100">
              <nav class="py-3">
                <Menu :menuitemClasses="menuitemClasses" @collapsedSider="collapsedSider"></Menu>
              </nav>

              <footer class="py-3">
                <span class="version event-options px-2 text-black">Powered by key4events - version 2.0.1 (2023-05-02)</span>
              </footer>
            </div>
          </div>
        </div>
      </Sider>

      <!------------------------------>
      <Layout class="main-content flex-grow-1">
        <Content class="d-flex flex-column px-3 pt-4">
          <router-view ref="routerView" class="flex-grow-1 pb-5" v-if="drawComponent" @exportPdf="exportPdf"></router-view>
          <footer class="k4-footer d-flex align-items-center bg-white px-3 py-3 w-100" style="z-index: 0;">
            <div class="col-6 d-flex align-items-center">
              <img src="../assets/logo-key_horizontal-black-xsmall.svg" />
              <p class="k4-footer__copyright mx-2 my-auto">@{{new Date().getFullYear()}} All rights reserved</p>
            </div>
            <div class="col-6 d-flex align-items-center justify-content-end">
              <a href="#" class="k4-footer__link mx-1 text-primary-dark text-decoration-underline">Brand</a>
              <a href="#" class="k4-footer__link mx-1 text-primary-dark text-decoration-underline">Information Privacy Statement</a>
              <a href="#" class="k4-footer__link mx-1 text-primary-dark text-decoration-underline">Terms of sale</a>
              <a href="#" class="k4-footer__link mx-1 text-primary-dark text-decoration-underline">Legal Notice</a>
            </div>
          </footer>
        </Content>
      </Layout>

      <Modal v-model="sharePDFModal" title="Share">
        <Form ref="shareForm" :model="shareForm" :rules="ruleValidate" :label-width="80">
          <FormItem label="E-mail" prop="mail">
            <Input v-model="shareForm.mail" placeholder="Enter your e-mail"></Input>
          </FormItem>
        </Form>
        <div slot="footer">
          <Button type="primary" @click="handleSubmit('shareForm')">Submit</Button>
        </div>
      </Modal>
      <div id="anchor"></div>
    </Layout>
  </main>
</template>

<script>
  import Menu from './Menu.vue'
  import ContentHeader from './Header.vue'
  import jsPDF from 'jspdf'
  import {mapActions, mapGetters} from 'vuex'
  import {bus} from '../main'
  import moment from 'moment-timezone'
  import Router from '../router';

  export default {
    name: 'Wrapper',
    data() {
      return {
        counter: 0,
        winWidth: 0,
        drawComponent: true,
        isCollapsed: false,
        menuClasses: ['menu-item'],
        sharePDFModal: false,
        shareForm: {
          mail: '',
        },
        ruleValidate: {
          mail: [
            {required: true, message: 'Mailbox cannot be empty', trigger: 'blur'},
            {type: 'email', message: 'Incorrect email format', trigger: 'blur'}
          ],
        },
        selectedEvent: '',
        eventListDefault: [],
        eventListExpired: [],
        eventListUpcoming: [],
        selectedCompany: '',
        companyList: [],
        userIcon: ''
      }
    },
    components: {
      Menu,
      ContentHeader
    },
    computed: {
      ...mapGetters(['getUserDetails', 'getAdminUser']),
      ...mapGetters(['getEvent', 'getEventList']),
      ...mapGetters(['getCompanyDetail', 'getCompanyListDetail']),
      ...mapGetters(['getLicenseDetail', 'getLicenseListDetail']),

      rotateIcon() {
        return [
          'menu-icon',
          this.isCollapsed = false
        ];
      },
      menuitemClasses() {
        return [
          'menu-item',
          //this.isCollapsed ? 'collapsed-menu' : ''
          this.isCollapsed = false
        ]
      }
    },
    watch: {
      selectedEvent: function (val) {
        // const self = this;
        let events = this.getEventList;
        if (val && val != 0) {
          let event = events.filter(a => a.eventName.toLowerCase() == val.toLowerCase());
          this.setEvent(event[0]);
          localStorage.setItem('selected_event', event[0].eventId)
          sessionStorage.setItem('eventName', event[0].eventName);
        } else {
          localStorage.setItem('selected_event', 0);
          sessionStorage.setItem('eventName', '');
          this.setEvent([]);
          Router.push({name: 'GlobalAdministration'});
        }

        let route = this.$router.currentRoute.name.toLowerCase();
        if (route.indexOf('global') > -1) {
          bus.$emit('getEvtName', val);
        }
        if (route.indexOf('dashboard') > -1) {
          bus.$emit('getEvtName', val);
        }
        if (route.indexOf('lead') > -1) {
          if (route.indexOf('processed') > -1) {
            bus.$emit('changeLeadsProcessedForms', val, localStorage.getItem('selected_company'));
          } else {
            bus.$emit('changeForm', val, localStorage.getItem('selected_company'));
          }
        }
        if (route.indexOf('questionnaire') > -1) {
          if (route.indexOf('processed') > -1) {
            bus.$emit('changeQuestionnaireProcessedForm', val, localStorage.getItem('selected_company'));
          } else {
            bus.$emit('changeSurveyForm', val, localStorage.getItem('selected_company'));
          }
        }
        if (route.indexOf('export') > -1) {
          bus.$emit('changeExportDataForm', val, localStorage.getItem('selected_company'));
        }
      },
      selectedCompany: function (val) {
        const self = this;
        let companies = this.getCompanyListDetail;
        let savedEvents = this.getEventList;

        let events = [];

        if (val && val != 0) {
          let company = companies.filter(a => a.companyName.toLowerCase() == val.toLowerCase());
          if (company.length > 0) {
            localStorage.setItem('selected_company', company[0].companyId);
            self.setCompanyDetail(company[0]);
            sessionStorage.setItem('companyName', company[0].companyName);

            //filter localStorage Events based on company.eventIds
            let eventIds = company[0].eventIds;

            savedEvents.map((evt, ix) => {
              for (let i = 0; i < eventIds.length; ++i) {
                if (eventIds[i] == evt.eventId) {
                  let returnData = {
                    eventName: evt.eventName,
                    eventId: evt.eventId,
                    startDate: evt.startDate,
                    endDate: evt.endDate,
                    location: evt.location,
                    iconUrl: evt.iconUrl,
                    bannerUrl: evt.bannerUrl,
                    companyIds: evt.companyIds,
                    formIds: evt.formIds,
                    leadIds: evt.leadIds,
                    licenseIds: evt.licenseIds,
                    participantForm: evt.participantForm,
                    participantIds: evt.participantIds,
                    userIds: evt.userIds,
                    deleted: evt.deleted,
                  };
                  events.push(returnData);
                }
              }
            });

            // localStorage.setItem('selected_event', 0);
            // self.selectedEvent = '';
            // self.setEvent([]);

            if (events.length > 0) {
              events = events.sort((a, b) => (a.endDate < b.endDate) ? 1 : ((b.endDate < a.endDate) ? -1 : 0));
              self.eventListDefault = events.filter(a => a.endDate == null);
              self.eventListExpired = events.filter(a => moment(a.endDate) < moment(new Date()));
              self.eventListUpcoming = events.filter(a => moment(a.endDate) >= moment(new Date()));
            }
          }
        } else {
          self.selectedCompany = '';
          self.eventListDefault = [];
          self.eventListExpired = [];
          self.eventListUpcoming = [];
          self.selectedEvent = '';
          localStorage.setItem('selected_event', 0);
          localStorage.setItem('selected_company', 0);
        }

        bus.$emit('changeForm', self.getEvent.eventId, val);
        bus.$emit('getCmpName', val);
      }
    },
    methods: {
      ...mapActions(['setUserDetails', 'setAdminUser']),
      ...mapActions(['setEvent', 'setEventList']),
      ...mapActions(['setCompanyDetail', 'setCompanyListDetail']),
      ...mapActions(['setLicenseDetail', 'setLicenseListDetail']),

      onMenuItemClick(){
        this.isCollapsed = !this.isCollapsed;
      },
      filterMethod(value, option) {
        let _value = value ? value.toUpperCase() : '';
        let _option = option ? option.toUpperCase() : '';
        return _option.indexOf(_value) !== -1;
      },
      handleResize() {
        this.winWidth = window.innerWidth;
        if (this.winWidth < 1207) {
          this.isCollapsed = true;
        } else {
          this.isCollapsed = false;
        }
      },
      documentClick(e) {
        let element = document.querySelector('.burgerIco');
        let target = null;
        if (e && e.target) {
          target = e.target;
        }

        if (
          element &&
          element !== target &&
          !element.contains(target) &&
          e.target.className !== 'ivu-layout-sider-children' &&
          e.target.className !== 'input.ivu-select-input' &&
          e.target.className !== 'event-options' &&
          e.target.className !== 'ivu-select-input' &&
          e.target.className !== 'ivu-select-selected-value' &&
          //e.target.className !== 'ivu-layout-content' &&
          e.target.className !== 'ivu-select-placeholder' &&
          e.target.className !== 'ivu-icon ivu-icon-ios-arrow-down ivu-select-arrow' &&
          e.target.className !== 'EVENT-OPTIONS' &&
          e.target.className !== 'ivu-select-selection' &&
          e.target.className !== 'ivu-input ivu-input-large' &&
          e.target.className !== 'ivu-icon ivu-icon-ios-search ivu-input-icon ivu-input-icon-normal' &&
          e.target.className !== 'ivu-icon ivu-icon-ios-close ivu-input-icon ivu-input-icon-normal' &&
          e.target.className !== 'version event-options' &&
          e.target.className !== 'tr' &&
          !this.isCollapsed &&
          this.winWidth < 768
        ) {
          this.isCollapsed = true;
        }
      },
      triggerExport() {
        this.$refs.routerView.triggerExportPdf();
      },
      async exportPdf(canvas, filename) {
        var vm = this;
        const el = canvas;
        const options = {
          type: 'dataURL'
        };
        await this.$html2canvas(el, options).then(function (canvas) {
          var doc = new jsPDF('l', "mm", "a4");
          var width = doc.internal.pageSize.getWidth();
          var height = doc.internal.pageSize.getHeight();

          doc.addImage(canvas, 'PNG', 0, 0, width, height);
          doc.save(filename)
        });
      },
      async sharePdf() {
        var vm = this;
        const el = this.$refs.widgetContainer;
        const options = {
          type: 'dataURL'
        };
        await this.$html2canvas(el, options).then(function (canvas) {
          var doc = new jsPDF('l', "mm", "a4");
          var width = doc.internal.pageSize.getWidth();
          var height = doc.internal.pageSize.getHeight();

          doc.addImage(canvas, 'PNG', 0, 0, width, height);
          return doc.output('save', 'net_performance_time_analysis.pdf')
//          return doc.output('datauri')
//          return doc.output('datauristring')
        });
      },
      collapsedSider() {
        this.$refs.sideMenu.toggleCollapse();
      },
      shareModal() {
        this.sharePDFModal = true
      },
      handleSubmit(name) {
        this.$refs[name].validate((valid) => {
          if (valid) {
            this.$Message.success('Success!');
            let s = this.$refs.routerView.sharePdf();
          }
        })
      },
      collectEventsData: function (events, companies) {
        if (companies) {
          if (companies.length > 0) {
            this.setCompanyDetail(companies[0]);
            this.setCompanyListDetail(companies);
            this.companyList = companies.map(a => a.companyName);
          }
        }
        if (events) {
          if (events.length > 0) {
            this.setEvent(events[0]);
            this.setEventList(events);
            events = events.sort((a, b) => (a.endDate < b.endDate) ? 1 : ((b.endDate < a.endDate) ? -1 : 0));
            this.eventListDefault = events.filter(a => a.endDate == null);
            this.eventListExpired = events.filter(a => moment(a.endDate) < moment(new Date()));
            this.eventListUpcoming = events.filter(a => moment(a.endDate) >= moment(new Date()));
          }
        }
      }
    },
    created() {
      window.addEventListener('resize', this.handleResize);
      this.handleResize();
      document.addEventListener('click', this.documentClick);

      let events = JSON.parse(localStorage.getItem('events'));
      let companies = JSON.parse(localStorage.getItem('companies'));
      this.collectEventsData(events, companies);
    },
    destroyed() {
      window.removeEventListener('resize', this.handleResize);
      document.removeEventListener('click', this.documentClick);
    },
    mounted() {
      this.isCollapsed = false;
      let selectedCompany = localStorage.getItem('selected_company');
      if (selectedCompany && selectedCompany != 0) {
        this.selectedCompany = this.getCompanyListDetail.filter(a => a.companyId == selectedCompany)[0].companyName;
      }
      let selectedEvent = localStorage.getItem('selected_event');
      if (selectedEvent && selectedEvent != 0) {
        let event = this.getEventList.filter(a => a.eventId == selectedEvent);
        this.selectedEvent = event[0].eventName;
      }
      bus.$on('reloadSideMenu', (events, companies) => {
        this.collectEventsData(events, companies);
      });
      bus.$on('resetCompany', () => {
        this.selectedCompany = '';
      });

      setTimeout(() => {
        document.getElementById('anchor').click();
      }, 400);
    }
  }
</script>

<style scoped>
  .k4-selectionContainer {
    background-color: var(--primary-light); 
    padding-top: 3%; 
    padding-bottom: 3%;
  }
  .k4-selectionContainer__wrapper {
    background-color: white; 
    border-radius: 5px;
  }
  .k4-key4leadLogoContainer {
    width: 70px; 
    border-right: 2px solid var(--gray-light);
  }
  .k4-key4leadLogoContainer__image {
    width: 1.5em;
    height: auto;
  }
  .main-content {
    background: transparent url('../assets/background_nav.svg') 0% 0% no-repeat padding-box;
    opacity: 1;
  }
  .k4-footer {
    height: 64px;
    z-index: 1000;
  }
  .k4-footer__copyright {
    color: #0003338A; 
    font-size: 0.8em;
  }
  .k4-footer__link {
    font-size: 0.9em;
  }
  .main-menu.ivu-layout-sider {
    position: fixed;
    height: 100vh;
    overflow-y: auto;
    overflow-x: hidden;
    z-index: 999;
  }

  .ivu-layout-sider-trigger {
    display: block !important;
  }

  /*.ivu-layout.ivu-layout-has-sider .main-content.ivu-layout {
    padding-top: 94px;
  }*/

  .ivu-layout.ivu-layout-has-sider.app-drawer-open .main-content.ivu-layout {
    padding-left: 320px;
  }

  .app-drawer-collapsed.content-wrapper > .ivu-layout:not(.authentication) {
    /*padding-left: 70px;*/
    padding-left: 0;
  }

  .layout {
    border: 1px solid #d7dde4;
    background: #f5f7f9;
    position: relative;
    border-radius: 4px;
    overflow: hidden;
  }

  .layout-header-bar {
    background: #fff;
    box-shadow: 0 1px 1px rgba(0, 0, 0, .1);
  }

  .layout-logo-left {
    width: 90%;
    height: 30px;
    background: #5b6270;
    border-radius: 3px;
    margin: 15px auto;
  }

  .menu-icon {
    transition: all .3s;
  }

  .ivu-layout-sider {
    background-color: var(--white);
  }

  .ivu-layout-sider ul {
    background-color: transparent;
  }

  .main-logo {
    position: absolute;
    bottom: 0;
    width: 100%;
  }

  .mines-logo img, .main-logo img {
    width: 265px;
    display: block;
    margin: 0 auto 20px auto;
    padding: 5px 10px 5px 10px;
    border-radius: 5px;
    /*filter: drop-shadow(3px 3px 6px white) drop-shadow(-3px -3px 6px white);*/
  }

  .bottom-right-logo {
    position: absolute;
    right: 8px;
    bottom: 8px;
  }
  .bottom-right-logo img {
    width: 265px;
  }

  .demo-auto-complete-item {
    padding: 4px 0;
    border-bottom: 1px solid #F6F6F6;
  }

  .demo-auto-complete-group {
    font-size: 12px;
    padding: 4px 6px;
  }

  .demo-auto-complete-group span {
    color: #666;
    font-weight: bold;
  }

  .demo-auto-complete-group a {
    float: right;
  }

  .demo-auto-complete-count {
    float: right;
    color: #999;
  }

  .demo-auto-complete-more {
    display: block;
    margin: 0 auto;
    padding: 4px;
    text-align: center;
    font-size: 12px;
  }

  .version {
    color: white;
    font-style: italic;
    font-size: 0.65em;
  }
</style>



// WEBPACK FOOTER //
// src/components/Wrapper.vue